import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import CenterModal from "../UI/Modal/CenterModal";
import { setIsIosPlayPauseIconModalOpen } from "../../reducers/common-reducer";
import { LogFirebase } from "../../services/firestore";
import useLanguageChange from "../../hooks/useLanguageChange";

const IosPlayPauseIconModal = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isIosPlayPauseIconModalOpen } = useSelector((state) => state.commonReducer);

    const playIfIosVideosPaused = () => {
        /* Get all video elements within the video tag*/
        const videos = document.querySelectorAll("video") || [];

        if (videos?.length > 0) {
            // Iterate over all Video elements
            videos.forEach((video) => {
                video
                    ?.play()
                    .then(() => {
                        LogFirebase("Video_play_pause", "_video_playing", "true");
                        console.log("outremote video played");
                    })
                    .catch((error) => {
                        LogFirebase("Video_play_pause", "Error_playing_video:", error);
                        console.log("error" + error);
                    });
            });
        } else {
            console.log("No video elements found in the container");
        }
        dispatch(setIsIosPlayPauseIconModalOpen(false));
    };

    const closeIosPlayIconModal = () => {
        playIfIosVideosPaused();
    };

    const handlePlayVideoButton = () => {
        closeIosPlayIconModal();
    };

    const iosPlayPauseIconModaldHeader = useMemo(() => {
        return (
            <>
                <h5 className='modal-title'>{localisedValues?.having_a_video_problem}</h5>
                <button type='button' className='btn-close' aria-label='Close' onClick={closeIosPlayIconModal}>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </>
        );
    }, [isIosPlayPauseIconModalOpen]);

    const iosPlayPauseIconModalBody = useMemo(() => {
        return (
            <div className='cms-modal-text'>
                <p>{localisedValues?.ios_play_pause_modal_body_text}</p>
            </div>
        );
    }, [isIosPlayPauseIconModalOpen]);

    const iosPlayPauseIconModalFooter = useMemo(() => {
        return (
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={handlePlayVideoButton}>
                        {localisedValues?.play_video}
                    </button>
                </div>
            </div>
        );
    }, [isIosPlayPauseIconModalOpen]);

    return (
        <CenterModal
            showModal={isIosPlayPauseIconModalOpen}
            closeModal={() => closeIosPlayIconModal()}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={iosPlayPauseIconModaldHeader}
            body={iosPlayPauseIconModalBody}
            footer={iosPlayPauseIconModalFooter}
            backdrop={"static"}
        />
    );
};

export default IosPlayPauseIconModal;
